enum PendingItemsActionEnum {
    BACKORDER = "backorder",
    REMOVE = "remove",
    ZERO_OUT = "zero_out",
}

export default PendingItemsActionEnum;
